import * as http from "./http";

type ApiShape = typeof http;

const api: ApiShape = http;

export {api};